import { MODEL_NAMES } from '../../../constants/index';
import { service } from '@ember/service';
import { setOwner } from '@ember/application';

export default class WebsocketActivityHandlersMessage {
  @service messaging;
  @service messagingNavigation;
  @service messagingLogging;
  @service store;

  constructor(owner) {
    setOwner(this, owner);
  }

  handleActivity(response) {
    const statusHandlers = {
      created: this.#handleCreatedActivity,
      destroyed: this.#handleDestroyedActivity,
    };
    const handler = response.status ? statusHandlers[response.status] : null;

    if (!handler) {
      this.messagingLogging.warn('Unhandled websocket message activity status', {
        action: 'message',
        status: response.status,
      });
      return;
    }

    handler.call(this, response.payload);
  }

  #handleCreatedActivity(payload) {
    const message = this.store.normalize(MODEL_NAMES.MESSAGE, payload.data);
    const {
      data: { attributes, relationships },
    } = message;
    const conversationId = relationships.conversation.data.id;

    let localRecord;
    if (attributes.localId) {
      localRecord = this.store
        .peekAll(MODEL_NAMES.MESSAGE)
        .find(record => record.localId === attributes.localId);
    }
    const currentHandler = this.messagingNavigation.currentConversationHandler;
    const isFromCurrentConversation = currentHandler?.conversation?.id === conversationId;
    const record = localRecord || this.store.push(message);

    if (isFromCurrentConversation && !this.#messageAlreadyPresent(currentHandler, record)) {
      currentHandler.messages?.unshiftObject(record);
    }

    if (!attributes.isSystem) {
      this.#updateConversationLastMessage(conversationId, record);
      if (!attributes.isOwn) {
        this.#addUnreadConversation(conversationId);
      }
    }
  }

  #handleDestroyedActivity(payload) {
    this.store.pushPayload(MODEL_NAMES.MESSAGE, payload);
  }

  #messageAlreadyPresent(handler, message) {
    return handler.messages?.content?.some(
      m => m.id === message.id || m.localId === message.localId
    );
  }

  #updateConversationLastMessage(conversationId, message) {
    const conversation = this.store.peekRecord(MODEL_NAMES.CONVERSATION, conversationId);
    if (!conversation) {
      this.messagingLogging.warn('Conversation missing when updating last message');
      return;
    }

    conversation.isDraft = false;
    conversation.updatedAt = new Date();
    conversation.lastMessage = message;
  }

  #addUnreadConversation(conversationId) {
    this.messaging.currentProfile.addUnreadConversation(conversationId);
  }
}
